<template>
  <el-dialog :title="getTitle"
             :visible.sync="showModal"
             @close="handleCancel"
             :close-on-click-modal="false"
             width="40%">
    <el-col :span="24">
      <el-form :model="repairInfo"
               :rules="repairRules"
               ref="repairForm"
               label-width="130px"
               class="repair-form">
        <el-form-item label="报修人："
                      prop="submitter">
          <el-input v-model.trim="repairInfo.submitter"
                    placeholder="请输入报修人"></el-input>
        </el-form-item>
        <el-form-item label="手机号："
                      prop="sub_phone_no">
          <el-input v-model="repairInfo.sub_phone_no"
                    placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item v-if="data.type === 'add'"
                      label="区域：">
          <el-select v-model="area_id"
                     placeholder="请选择区域"
                     @change="handleRoomChange">
            <el-option v-for="item in roomList"
                       :key="item.id"
                       :disabled="item.area_type === 'area_type_no'"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备编号："
                      prop="dev_sn">
          <el-select v-if="data.type === 'add'"
                     v-model="repairInfo.dev_sn"
                     placeholder="请选择设备编号">
            <el-option v-for="item in deviceList"
                       :key="item.sn"
                       :label="item.lock_name"
                       :value="item.sn">
            </el-option>
          </el-select>
          <p v-if="data.type === 'edit'">{{repairInfo.dev_sn}}</p>
        </el-form-item>
        <el-form-item label="故障描述："
                      prop="fault_desc">
          <el-input type="textarea"
                    maxlength="250"
                    v-model.trim="repairInfo.fault_desc"
                    placeholder="请输入故障描述"></el-input>
        </el-form-item>
        <el-form-item label="设备自检："
                      prop="check_up">
          <el-checkbox-group v-model="repairInfo.check_up">
            <el-checkbox v-for="item in typeList"
                         :key="item.value"
                         :label="item.code">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
    </el-col>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button v-has="'/repair/edit'"
                 type="primary"
                 @click="handleConfirm('repairForm')">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: Object
    }
  },
  data() {
    return {
      showModal: this.isShow,
      area_id: '',
      repairInfo: {
        dev_sn: '',
        fault_desc: '',
        check_up: [],
        submitter: '',
        sub_phone_no: ''
      },
      repairRules: {
        dev_sn: [{ required: true, message: '请选择设备编号' }],
        fault_desc: [{ required: true, message: '请输入故障描述' }],
        submitter: [{ required: true, message: '请输入报修人' }]
      },
      typeList: [],
      deviceList: [],
      roomList: [],
      tmpArr: []
    }
  },
  computed: {
    getTitle() {
      return this.data.type === 'add' ? '添加维修' : '编辑维修'
    }
  },
  created() {
    this.getItemList()
    if (this.data.type === 'edit') {
      this.repairInfo = this.data.data
      this.repairInfo.check_up = this.data.data.check_up ? this.data.data.check_up.split(',') : []
    } else {
      this.repairInfo.submitter = localStorage.getItem('username')
      this.repairInfo.sub_phone_no = localStorage.getItem('mobile')
      this.getAreaList()
    }
  },
  methods: {
    // 获取数据
    getAreaList() {
      fetch.getAreaTreeManage({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.roomList = this.titleFormat(data.treeData, '• ')
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 获取自检类型
    getItemList() {
      fetch.getItemList({ type_code: 'check_up' }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.typeList = data.list
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 获取设备列表
    roomLockList(val) {
      fetch.roomLockList({ area_id: val }).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.deviceList = data.list
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    handleRoomChange(val) {
      this.repairInfo.sn = ''
      this.roomLockList(val)
    },
    handleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let datas = JSON.parse(JSON.stringify(this.repairInfo))
          datas.check_up = datas.check_up.join(',')
          if (this.data.type === 'add') {
            fetch.addRepair({ ...datas }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.handleCancel('refresh')
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          } else {
            fetch.editSubmitRepair({ ...datas }).then((data) => {
              data.procData(
                data.res,
                () => {
                  this.$message.success('操作成功')
                  this.handleCancel('refresh')
                },
                (err) => {
                  this.$message.error(err)
                }
              )
            })
          }
        } else {
          return false
        }
      })
    },
    handleCancel(type) {
      this.$emit('handleClose', type)
    },
    //  格式化名称
    titleFormat(data, prefix) {
      if (data.length === 0) {
        return []
      }
      data.forEach((item) => {
        let tmp = item
        tmp.name = prefix + item.name
        this.tmpArr.push(tmp)
        if (item.children && item.children.length > 0) {
          this.titleFormat(item.children, '• ' + prefix)
        }
      })
      return this.tmpArr
    }
  }
}
</script>

<style></style>
